import {useLayoutEffect, useState} from 'react';

export const ActiveUnderlineWrapper = ({children, navigationItem, currentHoveredItemId, isShopActive, lightMode}) => {
    const [showUnderline, setShowUnderline] = useState(navigationItem.active);

    useLayoutEffect(() => {
        if (currentHoveredItemId === navigationItem.id) {
            setShowUnderline(true);
        } else {
            if (!currentHoveredItemId && isShopActive) {
                setShowUnderline(navigationItem.active);
            } else {
                setShowUnderline(false);
            }
        }
    }, [currentHoveredItemId, navigationItem.id, navigationItem.active, isShopActive]);
    const classes = `${showUnderline ? 'navigation__item-underlined' : ''} ${lightMode ? 'text-clr-on-primary-high' : 'text-clr-primary'}`;
    return <div className={classes}>{children}</div>;
};
